// Presentation state follows service results, never translated error strings.
export function supportFailure(error) {
  const code = String(error?.code || error?.status || '');
  const message = String(error?.message || '').toLowerCase();
  if (['401', 'PGRST301', 'PGRST302'].includes(code) || /authentication required|jwt expired/.test(message)) return 'auth';
  if (['403', '42501'].includes(code) || /permission denied|row-level security|not yet enabled|still being enabled/.test(message)) return 'denied';
  return 'unavailable';
}

export function supportAvailability({ signedIn, loading, failure = '' }) {
  return signedIn && !loading && !failure;
}

const topics = new Set(['account_access','technical_issue','billing_inquiry','consultation_support','general_inquiry','feature_request']);
export function readSupportHandoff(search = '', pathname = '') {
  let params = new URLSearchParams(search);
  if (pathname === '/login' || pathname === '/pharmacy') {
    const next = params.get('next') || '';
    if (!/^\/(?:help(?:\/|\?|$)|help-support(?:\?|$)|pharmacy\/help(?:\/|\?|$))/.test(next) || next.includes('\\')) return {};
    params = new URL(next, 'https://app.afrimed.tech').searchParams;
  } else if (!/^\/(?:help(?:\/|$)|help-support$|pharmacy\/help(?:\/|$)|forgot-password$)/.test(pathname)) return {};
  return {
    language: ['en-GB', 'fr'].includes(params.get('lang')) ? params.get('lang') : '',
    topic: topics.has(params.get('topic')) ? params.get('topic') : '',
    source: params.get('source') === 'website' ? 'website' : '',
  };
}

export const supportCopy = {
  en: {
    'helpSupport.escalation.body': 'If the guidance does not solve the issue, send AfriMed™ support a request. We’ll review it and route it to the right team.',
    'helpSupport.requests.description': 'Your requests and their current status appear here. Open a request to read its replies.',
    'helpSupport.empty.default': 'Create a support request if you need AfriMed™ Support to review something.',
    'helpSupport.errors.permission': 'Support access could not be confirmed for this account. Retry or use the account-access guidance.',
    'helpSupport.actions.supportPending': 'Support temporarily unavailable',
    'helpSupport.actions.supportPendingTitle': 'Retry loading support before creating a request.',
    'helpSupport.accessPending.title': 'Support unavailable',
  },
  fr: {
    'helpSupport.escalation.body': 'Si le guide ne résout pas le problème, envoyez une demande à l’assistance AfriMed™. Nous l’examinerons et l’orienterons vers la bonne équipe.',
    'helpSupport.requests.description': 'Vos demandes et leur statut actuel apparaissent ici. Ouvrez une demande pour lire les réponses.',
    'helpSupport.empty.default': 'Créez une demande si vous avez besoin de l’aide de l’équipe AfriMed™.',
    'helpSupport.errors.permission': 'L’accès à l’assistance n’a pas pu être confirmé pour ce compte. Réessayez ou consultez l’aide à la connexion.',
    'helpSupport.actions.supportPending': 'Assistance temporairement indisponible',
    'helpSupport.actions.supportPendingTitle': 'Rechargez l’assistance avant de créer une demande.',
    'helpSupport.accessPending.title': 'Assistance indisponible',
  },
};
